import React, { useState, useEffect } from 'react';
import portfolioAPI from '../services/portfolioAPI';
import './Projects.css';

const Projects = () => {
  const [activeProject, setActiveProject] = useState(null);
  const [projectsData, setProjectsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const projects = await portfolioAPI.getProjects().catch(err => {
          console.log('Projects API failed, using fallback data');
          return [
            {
              id: "1",
              title: "Full Stack Chat Application",
              description: "Real-time messaging application with user authentication, different themes, and message history.",
              technologies: ["React", "Node.js", "Socket.io", "MongoDB", "Express"],
              features: [
                "Real-time messaging",
                "User authentication",
                "All your files are secured",
                "Message history",
                "File sharing",
                "Responsive design"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/Fullstack-chat-app",
              demo_url: "https://fullstack-chat-app-pb32.onrender.com/"
            },
            {
              id: "2",
              title: "Mock Mentor - AI",
              description: "FastTrackHire is an AI-powered mock interview web application built with Python, Streamlit, and LLMs (LLaMA3.1-8B) to help users practice and improve their interview skills.",
              technologies: ["Python", "Streamlit", "LLMs", "LLaMA3.1-8B"],
              features: [
                "AI-powered mock interviews",
                "Interview feedback",
                "Customizable questions",
                "Performance analytics",
                "User-friendly interface",
                "Secure data handling"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/MockMentor-AI",
              demo_url: "https://mockmentor-ai.streamlit.app/"
            },
            {
              id: "3",
              title: "Carbon Footprint Tracker",
              description: "Web application to track and analyze personal carbon footprint with insights and recommendations.",
              technologies: ["TypeScript", "React", "SQLite", "Chart.js"],
              features: [
                "Carbon footprint calculation",
                "Data visualization",
                "Sustainability tips",
                "Progress tracking",
                "Comparative analysis",
                "Mobile responsive"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/1M1B-intern-project",
              demo_url: "https://carbon-reduction-challenge.onrender.com"
            },
            {
              id: "4",
              title: "Immunization Tracker",
              description: "Healthcare application to track vaccination schedules and reminders for individuals and families.",
              technologies: ["React", "Node.js", "Firebase", "Express", "Javascript"],
              features: [
                "Vaccination schedule tracking",
                "Reminder notifications",
                "Family member management",
                "Medical record storage",
                "Healthcare provider integration",
                "Mobile responsive"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/Immunization-Tracker",
              demo_url: "https://immunization-tracker-966d8.web.app/"
            },
            {
              id: "5",
              title: "MediLens AI",
              description: "MediLens AI is a browser-based multimodal health assistant. It integrates the Blink SDK for authentication, storage, database, and AI-powered features.",
              technologies: ["Python", "TypeScript", "React", "Tailwind CSS", "Blink"],
              features: [
                "Medical image analysis",
                "AI-powered diagnosis suggestions",
                "Symptom checker",
                "Medical history tracking",
                "Voice Analysis",
                "Secure data handling"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/MediLens-AI",
              demo_url: "https://medilens-ai-pi.vercel.app/"
            },
            {
              id: "6",
              title: "Personal Finance Manager",
              description: "Track your daily expenses and discover your carbon footprint with smart tips to live sustainably.",
              technologies: ["TypeScript", "React", "Supabase", "Chart.js", "Tailwind CSS"],
              features: [
                "Authentication (Signup, Login, Profile management)",
                "Track income & expenses with categories",
                "Budget management with alerts",
                "Interactive visual insights (charts & reports)",
                "Carbon Footprint Tracker for sustainable living",
                "Export transaction history (CSV / PDF)",
                "Responsive UI for web & mobile"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/Sustainable-Finance-Manager",
              demo_url: "https://personal-finance-manager-g18h.onrender.com/"
            },
            {
              id: "7",
              title: "ROI MERN APP",
              description: "It's a MERN stack project that manages all the information about the stocks and we can automate the different tools.",
              technologies: ["TypeScript", "React", "MongoDB", "Node.js", "Multer", "Express"],
              features: [
                "Authentication (Signup, Login, Profile management)",
                "Investment Dashboard",
                "Stock Investment",
                "Payment Management",
                "Withdrawal System",
                "Portfolio Tracking",
                "Responsive UI for web & mobile"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/ROI-MERN-APP",
              demo_url: "https://roi-mern-app-frontend-3a5f.onrender.com"
            },
            {
              id: "8",
              title: "Self Correcting RAG System",
              description: "A Retrieval-Augmented Generation (RAG) system that uses user feedback to iteratively improve the quality of generated responses over time.",
              technologies: ["TypeScript", "React", "HTML", "Gemini 3.5"],
              features: [
                "Retrieval-Augmented Generation",
                "User feedback integration",
                "Iterative response improvement",
                "Contextual understanding",
                "Scalable architecture",
                "Secure data handling"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/Self-Correcting-RAG",
              demo_url: "#"
            },
            {
              id: "9",
              title: "Personalized Learning Assistant",
              description: "An AI-powered assistant that adapts learning content to individual student needs and preferences for their examinations.",
              technologies: ["TypeScript", "React 18", "HTML", "LLaMA3.5-8B", "pdfjs-dist", "mammoth(DOCX parsing)"],
              features: [
                "Retrieval-Augmented Generation based question answering",
                "User feedback integration by LLaMa3.5-8B",
                "Mock Exam Simulation",
                "7-Day Study Planner",
                "Comprehensive PDF Exports",
                "Cloud Database Tracking"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/Personalized-Learning-Assistant",
              demo_url: "#"
            },
            {
              id: "10",
              title: "Health Preparation Assistant",
              description: "An AI-powered assistant that helps users prepare for health-related tests before going to an appointment.",
              technologies: ["TypeScript", "React 18", "HTML", "Gemini 3.5"],
              features: [
                "Real-time Voice Interaction",
                "Intelligent Prep Management",
                "Patient Security & Profile Management",
                "Adaptive Onboarding & Guidance"
              ],
              status: "Completed",
              github_url: "https://github.com/KowshikSuggala25/HealthPrep",
              demo_url: "#"
            },
          ];
        });
        
        setProjectsData(projects);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching projects:', error);
        setError('Failed to load projects');
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const handleProjectClick = (project) => {
    setActiveProject(activeProject === project.id ? null : project.id);
  };

  if (loading) {
    return (
      <section id="projects" className="projects-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Featured Projects</h2>
            <div className="title-underline"></div>
          </div>
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading projects...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="projects" className="projects-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Featured Projects</h2>
            <div className="title-underline"></div>
          </div>
          <div className="error-container">
            <p>Error: {error}</p>
            <p>Displaying fallback projects...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Featured Projects</h2>
          <div className="title-underline"></div>
        </div>
        <div className="projects-grid">
          {projectsData.map((project) => (
            <div 
              key={project.id} 
              className={`project-card ${activeProject === project.id ? 'active' : ''}`}
              onClick={() => handleProjectClick(project)}
            >
              <div className="project-card-inner">
                <div className="project-front">
                  <div className="project-header">
                    <h3 className="project-title">{project.title}</h3>
                    <div className={`project-status ${project.status.toLowerCase().replace(' ', '-')}`}>
                      {project.status}
                    </div>
                  </div>
                  <p className="project-description">{project.description}</p>
                  <div className="project-tech">
                    {project.technologies.map((tech, index) => (
                      <span key={index} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                  <div className="project-cta">
                    <span>Click to explore</span>
                    <div className="arrow-icon">→</div>
                  </div>
                </div>
                <div className="project-back">
                  <h4>Key Features:</h4>
                  <ul className="features-list">
                    {project.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                  <div className="project-links">
                    {project.github_url && (
                      <a href={project.github_url} className="project-link github" target="_blank" rel="noopener noreferrer">
                        <span>GitHub</span>
                      </a>
                    )}
                    {project.demo_url && (
                      <a href={project.demo_url} className="project-link demo" target="_blank" rel="noopener noreferrer">
                        <span>Live Demo</span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;